import { RotateCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export function PermissionBlockedContent({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="flex flex-col gap-3">
      <p>
        Your browser stopped this page from reaching the ATS runtime on this computer. Allow local network access for this site, then try
        again.
      </p>
      <Tabs defaultValue="chrome">
        <TabsList>
          <TabsTrigger value="chrome">Chrome / Edge</TabsTrigger>
          <TabsTrigger value="firefox">Firefox</TabsTrigger>
          <TabsTrigger value="safari">Safari</TabsTrigger>
        </TabsList>
        <TabsContent value="chrome" className="pt-2 text-sm">
          <ol className="list-decimal space-y-1 pl-5">
            <li>Click the site settings icon to the left of the address bar.</li>
            <li>Find "Local network access" and choose Allow.</li>
            <li>Reload this page.</li>
          </ol>
          <div className="mt-2 grid h-32 place-items-center rounded-md border border-dashed text-xs text-muted-foreground">
            Screenshot: Chrome site settings
          </div>
        </TabsContent>
        <TabsContent value="firefox" className="pt-2 text-sm">
          <ol className="list-decimal space-y-1 pl-5">
            <li>Open the permissions panel from the address bar.</li>
            <li>Allow connections to localhost for this site.</li>
            <li>Reload this page.</li>
          </ol>
        </TabsContent>
        <TabsContent value="safari" className="pt-2 text-sm">
          <ol className="list-decimal space-y-1 pl-5">
            <li>Open Safari › Settings for This Website.</li>
            <li>Allow local network access.</li>
            <li>Reload this page.</li>
          </ol>
        </TabsContent>
      </Tabs>
      <Button onClick={onRetry} className="self-start">
        <RotateCw aria-hidden /> Try again
      </Button>
    </div>
  );
}

export function PermissionBlockedDialog({
  open,
  onOpenChange,
  onRetry,
}: {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  onRetry: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-xl">
        <DialogHeader>
          <DialogTitle>Allow ATS to reach your runtime</DialogTitle>
          <DialogDescription>Needed once per browser.</DialogDescription>
        </DialogHeader>
        <PermissionBlockedContent onRetry={onRetry} />
      </DialogContent>
    </Dialog>
  );
}
